import React, { useState, useEffect } from 'react';
import { 
  Modal, 
  Button, 
  Form, 
  Select, 
  message, 
  Row, 
  Col, 
  Input 
} from "antd";
import { platformApi } from '../../../../api';

const { Option } = Select;

const ChangeOrderStatusReceived = ({ open, close, reloadData, chassis = '', form }) => {
  const { getFieldDecorator, getFieldValue, setFieldsValue } = form;
  const [loading, setLoading] = useState(false);
  const [regOptions, setRegOptions] = useState([]);
  const [fetching, setFetching] = useState(false);
  const [branchOptions, setBranchOptions] = useState([]);

  useEffect(() => {
    if (open) {
      setFieldsValue({
        status: "ORDERED",
        registrationNumbers: []
      });
      fetchRegistrationNumbers("ORDERED", chassis);
      fetchBranches();
    }
  }, [open]);

  const fetchRegistrationNumbers = (status, search = "") => {
    setFetching(true);
    platformApi.post(`/api/numberplate/get`, {
      status,
      searchString: search,
    })
      .then((res) => {
        const options = res.data.data.numberPlates.map(obj => ({
          value: obj.registerNo,
          label: obj.registerNo
        }));
        setRegOptions(options);

        if (chassis && options.length > 0) {
          const match = options.find(opt => opt.value === chassis);
          setFieldsValue({
            registrationNumbers: [match ? match.value : options[0].value]
          });
        }
      })
      .catch(() => {
        message.error("Failed to fetch registration numbers");
      })
      .finally(() => {
        setFetching(false);
      });
  };

  const fetchBranches = () => {
    platformApi.get(`/api/company/branches`)
      .then((res) => {
        if (res.data?.response?.data) {
          const options = res.data.response.data.map(branch => ({
            value: branch.id,
            label: branch.name
          }));
          setBranchOptions(options);
        } else {
          message.warning("No branches found");
        }
      })
      .catch(() => {
        message.error("Failed to fetch branches");
      });
  };

  const handleSearch = (value) => {
    // Only allow search when chassis is empty
    if (!chassis) {
      fetchRegistrationNumbers(
        getFieldValue('status') || "ORDERED", 
        value
      );
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    form.validateFields((err, values) => {
      if (!err) {
        setLoading(true);
        const endpoint = "/api/numberplate/status/received";
        platformApi.post(endpoint, {
          registerNos: values.registrationNumbers,
          branchId: values.branch
        })
          .then(() => {
            message.success(`Status changed to received successfully`);
            close();
            reloadData();
          })
          .catch(() => {
            message.error("Failed to update status");
          })
          .finally(() => {
            setLoading(false);
          });
      }
    });
  };

  return (
    <Modal
      width="40%"
      title="Update Received Number Plates"
      visible={open}
      onCancel={close}
      onOk={handleSubmit}
      confirmLoading={loading}
      okText="Update to Received"
    >
      <Form onSubmit={handleSubmit}>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item label="Registration Numbers">
              {getFieldDecorator('registrationNumbers', {
                rules: [{ required: true, message: 'Please select at least one registration number' }]
              })(
                <Select
                  mode="multiple"
                  placeholder="Select registration numbers"
                  loading={fetching}
                  filterOption={false}
                  onSearch={handleSearch}
                  showSearch
                  allowClear={!chassis}
                  disabled={!!chassis}
                >
                  {regOptions.map(option => (
                    <Option key={option.value} value={option.value}>
                      {option.label}
                    </Option>
                  ))}
                </Select>
              )}
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item label="Branch">
              {getFieldDecorator('branch', {
                rules: [
                  { required: true, message: 'Please select a branch' }
                ]
              })(
                <Select
                  placeholder="Select branch"
                  loading={!branchOptions.length}
                  allowClear
                  showSearch
                  optionFilterProp="children"
                >
                  {branchOptions.map(option => (
                    <Option key={option.value} value={option.value}>
                      {option.label}
                    </Option>
                  ))}
                </Select>
              )}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default Form.create()(ChangeOrderStatusReceived);
